const header = {
  name: 'Annas Alghoffar',
  profilePicture: './profile.png',
  job: 'Frontend Developer',
};

export default header;
